export default function qualitiesMayHaveChanged(messages = {}) {
  const {
    defaultMessages = [],
    standardMessages = [],
  } = messages;
  return standardMessages.length > 0 || defaultMessages.length > 0;
}